import { useI18n } from "@/context/I18nContext";

export const Chips = ({ items, value, onChange, label, testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {items.map((k) => (
      <button key={k} type="button" data-testid={`${testid}-${k}`} onClick={() => onChange(k)}
        className={`px-2.5 py-1 rounded-md text-[10px] font-mono uppercase border transition-colors ${value === k ? "border-[#3ad7ff]/70 text-white bg-[#2f7bff]/15 shadow-[0_0_12px_-4px_#3ad7ff]" : "border-white/10 text-slate-500 hover:text-slate-300"}`}>
        {label(k)}
      </button>
    ))}
  </div>
);

export const StickerOptions = ({ opt, setOpt, anims }) => {
  const { t } = useI18n();
  const set = (k) => (v) => setOpt((o) => ({ ...o, [k]: v }));
  return (
    <div className="space-y-2.5 rounded-lg border border-white/5 bg-white/[0.015] p-3" data-testid="sticker-options">
      <Row label={t("st.pos_start")}><Chips testid="sticker-pos" items={["center", "top", "bottom", "left", "right"]} value={opt.pos} onChange={set("pos")} label={(k) => t(`st.pos_${k}`)} /></Row>
      <Row label={t("st.anim")}><Chips testid="sticker-anim" items={anims} value={opt.anim} onChange={set("anim")} label={(k) => t(`st.anim_${k}`)} /></Row>
      <div className="flex flex-wrap items-center gap-4">
        <Row label={t("st.size")}><Chips testid="sticker-size" items={["s", "m", "l"]} value={opt.size} onChange={set("size")} label={(k) => t(`st.size_${k}`)} /></Row>
        <Row label={`${t("st.duration")} · ${opt.d}s`}>
          <input type="range" min="0.8" max="4" step="0.1" value={opt.d} onChange={(e) => set("d")(Number(e.target.value))}
            className="w-32 accent-[#a746ff]" data-testid="sticker-duration-slider" />
        </Row>
      </div>
    </div>
  );
};

const Row = ({ label, children }) => (
  <div className="space-y-1">
    <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
    {children}
  </div>
);
